import { render, staticRenderFns } from "./ProfitReportTableUser.vue?vue&type=template&id=137fa902&scoped=true"
import script from "./ProfitReportTableUser.vue?vue&type=script&lang=js"
export * from "./ProfitReportTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137fa902",
  null
  
)

export default component.exports